/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import api from '../../api'

export default {
  SET_PRIVILEGES (state, privileges) {
    state.privileges = privileges;
  },
  SET_IS_SYSTEM (state, isSystem) {
    state.isSystem = isSystem;
  },
}
